import "./footer.css"
import * as React from 'react';
import { Container, Row, Col, } from 'react-bootstrap';

function Footer() {

    return (


        <Container fluid className="container-fluid-footer">
        <Row>
            <Col lg={12} md={12} sm={12} xs={12} xxs={12} className="col-footer-text">
            <label className="footer-label">Version 19.1</label>
            </Col>
        </Row>
        </Container>

    );
}

export default Footer;